<template>
  <div>
    <div>
      <label class="text-[13px] font-semibold text-foreground pl-0.5">{{
        $t('newcomponent.datasets.origin.label')
      }}</label>
      <div class="grid grid-cols-1 gap-2 mt-2.5">
        <InputRadio v-for="option in options" :id="option.id" :key="option.id"
          :name="option.name" :value="option.value" :label="option.label"
          :description="option.description"
          v-model="newComponentStore.newComponent.dataOrigin"
          :options="options" />
      </div>
    </div>

    <div class="mt-5">
      <label class="text-[13px] font-semibold text-foreground pl-0.5">{{ $t('newcomponent.datasets.type.label')
        }}</label>
      <div class="grid grid-cols-1 gap-2 mt-2.5">
        <InputRadio v-for="option in invoiceOptions" :id="option.id"
          :key="option.id" :name="option.name" :value="option.value"
          :label="option.label" :description="option.description"
          v-model="newComponentStore.newComponent.dataType"
          :options="options" />
      </div>
    </div>
  </div>

</template>

<script setup lang="ts">
import InputRadio from '../../components/form/input/InputRadio.vue';
import { useNewComponentStore } from '../../stores/newComponentStore'
import { DocumentTypeOption, RadioOption } from '../../SalesReport'
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const newComponentStore = useNewComponentStore();

const options: RadioOption[] = [
  {
    id: 'all',
    name: 'all',
    value: 'all',
    label: t('newcomponent.datasets.origin.all'),
    description: t('newcomponent.datasets.origin.all_description')
  },
  {
    id: 'web',
    name: 'web',
    value: 'web',
    label: t('newcomponent.datasets.origin.web'),
    description: t('newcomponent.datasets.origin.web_description')
  }
]

const invoiceOptions: DocumentTypeOption[] = [
  {
    id: 'receipts',
    name: 'receipts',
    value: 'all',
    label: t('newcomponent.datasets.type.receipts'),
    description: t('newcomponent.datasets.type.receipts_description')
  },
  {
    id: 'invoice',
    name: 'invoices',
    value: 'deposit',
    label: t('newcomponent.datasets.type.invoices'),
    description: t('newcomponent.datasets.type.invoices_description')
  }
]
</script>